const DEFAULT_API_BASE_URL = 'http://localhost:8000/api';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '') || DEFAULT_API_BASE_URL;

const buildUrl = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

const parseResponse = async (response) => {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    return response.json();
  }

  return response.text();
};

const normalizeError = async (response) => {
  const payload = await parseResponse(response);

  if (typeof payload === 'string' && payload.trim()) {
    return payload;
  }

  if (payload?.detail) {
    return payload.detail;
  }

  if (payload?.error) {
    return payload.error;
  }

  if (payload?.non_field_errors?.length) {
    return payload.non_field_errors.join(' ');
  }

  if (payload && typeof payload === 'object') {
    const firstEntry = Object.values(payload).find((value) => value);

    if (Array.isArray(firstEntry)) {
      return firstEntry.join(' ');
    }

    if (typeof firstEntry === 'string') {
      return firstEntry;
    }
  }

  return 'Network response was not ok';
};

export const postJson = async (path, payload) => {
  const response = await fetch(buildUrl(path), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(payload)
  });

  if (!response.ok) {
    throw new Error(await normalizeError(response));
  }

  return parseResponse(response);
};

export const postFormData = async (path, formData) => {
  const response = await fetch(buildUrl(path), {
    method: 'POST',
    body: formData
  });

  if (!response.ok) {
    throw new Error(await normalizeError(response));
  }

  return parseResponse(response);
};

export const getJson = async (path) => {
  const response = await fetch(buildUrl(path), {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(await normalizeError(response));
  }

  return parseResponse(response);
};
